import { GameManager } from "../Game/Managers/GameManager";

export class PlayerConfiguration {
    private config: any;

    constructor(config: any) {
        this.config = config;
    }

    public getConfig(name: string): any {
        if (this.config != null && this.config[name] != null) {
            return this.config[name];
        }

        return null;
    }

    public update(data: any): Promise<any> {
        return GameManager.gameClient.sendPlayerConfigurationRequest(data);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Common/PlayerConfiguration.ts
 **/